module.exports = "<span v-html=formatValue></span>";